export class ConfigReader {
  /**
   * decided
   * @returns
   */
  public static getApiDomain() {
    switch (window.location.hostname) {
      case 'staging.skin-seoul.com':
        return 'https://staging-api.skin-seoul.com';
      case 'localhost':
        return 'https://dev-api.skin-seoul.com';
      case 'dev.skin-seoul.com':
        return 'https://dev-api.skin-seoul.com';
      case 'skin-seoul.com':
      default:
        return 'https://api.skin-seoul.com';
    }
  }

  /**
   * decided
   * @returns
   */
  public static getFrontendOrigin() {
    switch (window.location.hostname) {
      case 'staging.skin-seoul.com':
        return 'https://staging.skin-seoul.com';
      case 'localhost':
        return 'https://dev.skin-seoul.com';
      case 'dev.skin-seoul.com':
        return 'https://dev.skin-seoul.com';
      case 'skin-seoul.com':
      default:
        return 'https://skin-seoul.com';
    }
  }

  /**
   * Get event origin URL based on hostname
   * @returns
   */
  public static getEventOrigin() {
    switch (window.location.hostname) {
      case 'staging.skin-seoul.com':
        return 'https://staging-event.skin-seoul.com';
      case 'localhost':
        return 'https://dev-event.skin-seoul.com';
      case 'dev.skin-seoul.com':
        return 'https://dev-event.skin-seoul.com';
      case 'skin-seoul.com':
      default:
        return 'https://event.skin-seoul.com';
    }
  }

  /**
   * Get media origin URL based on hostname
   * @returns
   */
  public static getMediaOrigin() {
    switch (window.location.hostname) {
      case 'staging.skin-seoul.com':
        return 'https://staging-media.skin-seoul.com';
      case 'localhost':
        return 'https://dev-media.skin-seoul.com';
      case 'dev.skin-seoul.com':
        return 'https://dev-media.skin-seoul.com';
      case 'skin-seoul.com':
      default:
        return 'https://media.skin-seoul.com';
    }
  }

  public static getAnalyticsHmacSecret() {
    switch (window.location.hostname) {
      case 'skin-seoul.com':
        return '236012bac2c987ae9bfd09fd2e9260a5596edea53433ce1a3857fd1c59ef2ccc';
      default:
        return '9c291f05c481324ec5c9c645aca62e9241ec02338aeb7d9c5487c4314526b73c';
    }
  }
}
